import styled from 'styled-components';

export const StyledButton = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    outline: none;
    padding: 0;
    margin: 0;
    position: absolute;
    z-index: 9999;
`;
